<template>
           <svg
              width="30"
              height="37"
              viewBox="0 0 35 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7015 45.7251C2.4582 26.5263 0 24.5559 0 17.5C0 7.83499 7.83499 0 17.5 0C27.165 0 35 7.83499 35 17.5C35 24.5559 32.5418 26.5263 19.2985 45.7251C18.4294 46.9806 16.5705 46.9805 15.7015 45.7251ZM17.5 24.7917C21.5271 24.7917 24.7917 21.5271 24.7917 17.5C24.7917 13.4729 21.5271 10.2083 17.5 10.2083C13.4729 10.2083 10.2083 13.4729 10.2083 17.5C10.2083 21.5271 13.4729 24.7917 17.5 24.7917Z"
                fill="#1E90FF"
              />
            </svg>
</template>